<!-- =========================================================================================
	File Name: App.vue
	Description: Main vue file - APP
	----------------------------------------------------------------------------------------
	Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="app" :class="vueAppClasses">
    <router-view @setAppClasses="setAppClasses" />
  </div>
</template>

<script>
import themeConfig from "@/../themeConfig.js";
import router from "./router";
export default {
  data() {
    return {
      vueAppClasses: [],
    };
  },
  watch: {
    "$store.state.theme"(val) {
      this.toggleClassInBody(val);
    },
    "$vs.rtl"(val) {
      document.documentElement.setAttribute("dir", val ? "rtl" : "ltr");
    },
  },
  methods: {
    toggleClassInBody(className) {
      if (className == "dark") {
        if (document.body.className.match("theme-semi-dark"))
          document.body.classList.remove("theme-semi-dark");
        document.body.classList.add("theme-dark");
      } else if (className == "semi-dark") {
        if (document.body.className.match("theme-dark"))
          document.body.classList.remove("theme-dark");
        document.body.classList.add("theme-semi-dark");
      } else {
        if (document.body.className.match("theme-dark"))
          document.body.classList.remove("theme-dark");
        if (document.body.className.match("theme-semi-dark"))
          document.body.classList.remove("theme-semi-dark");
      }
    },
    setAppClasses(classesStr) {
      this.vueAppClasses.push(classesStr);
    },
    handleWindowResize() {
      this.$store.commit("UPDATE_WINDOW_WIDTH", window.innerWidth);

      // Set --vh property
      document.documentElement.style.setProperty(
        "--vh",
        `${window.innerHeight * 0.01}px`
      );
    },
    handleScroll() {
      this.$store.commit("UPDATE_WINDOW_SCROLL_Y", window.scrollY);
    },
  },
  mounted() {
    console.log(window.location.pathname);
    if (window.location.pathname == "/muhasebe-kategorileri") {
      router.push("/muhasebe-kategorileri");
    }
    this.toggleClassInBody(themeConfig.theme);
    this.$store.commit("UPDATE_WINDOW_WIDTH", window.innerWidth);

    let vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  },
  created() {
    // this.$store.dispatch('initAuth')
    const data = [];

    data["servisAdresi"] = localStorage.getItem("servisAdresi");
    data["id"] = localStorage.getItem("id");
    data["employeeid"] = localStorage.getItem("employeeid");
    data["firmaAdi"] = localStorage.getItem("firmaAdi");
    data["COMPANYNAME"] = localStorage.getItem("COMPANYNAME");

    data["tokenId"] = localStorage.getItem("tokenId");

    data["COMPANYID"] = localStorage.getItem("COMPANYID");
    data["EMPLOYEENO"] = localStorage.getItem("EMPLOYEENO");
    data["EMAIL"] = localStorage.getItem("EMAIL");
    data["USERLONGNAME"] = localStorage.getItem("USERLONGNAME");
    var result
    console.log(localStorage.getItem("tokenId"))
    if (localStorage.getItem("tokenId"))
      result = localStorage.getItem("tokenId").substring(1, 7);
    data["mailCode"] = result;
    data["loginpng"] = localStorage.getItem("loginpng");
    data["GROUPCODE"] = localStorage.getItem("GROUPCODE");

    this.$store.commit("setToken", data);
    if (window.location.pathname == "/muhasebe-kategorileri") {
      router.push("/muhasebe-kategorileri");
    }
    let dir = this.$vs.rtl ? "rtl" : "ltr";
    document.documentElement.setAttribute("dir", dir);

    window.addEventListener("resize", this.handleWindowResize);
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("resize", this.handleWindowResize);
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
